/**
 * For most paths, we can redirect exactly the same. Exception to this rule being /login/dashboard which is permanently
 * sunset
 */
export const getFinalDestinationForLoginDashboard = (path: string): string =>
    path.replace('/login/dashboard', '/mortgage/dashboard/login');
